//import { useParams } from 'react-router';
import { PropsWithChildren, useState } from 'react';
import { ResendEmail, useQueryString } from 'hooks';
import { Button, Icon } from 'components/structure';
import * as S from './Modal.styles';
export type ModalProps = {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  icon?: JSX.Element;
  content?: JSX.Element;
  noBackground?: boolean;
  noIconContainer?: boolean;
  title: string;
  description?: string;
  confirmation?: string;
  name?: string;
  buttonLabel?: string;
  hasButton?: boolean;
  isShort?: boolean;
  isStrong?: boolean;
  onClose?: () => void;
  isConfirmation?: boolean;
  colorSchema?: 'dark' | 'light';
};

export const Modal = ({
  showModal,
  setShowModal,
  icon,
  title,
  description,
  confirmation,
  buttonLabel,
  noBackground,
  noIconContainer,
  name,
  hasButton = true,
  isShort,
  isStrong,
  onClose,
  children,
  content,
  isConfirmation,
}: PropsWithChildren<ModalProps>) => {
  const { uuid } = useQueryString() as { uuid: string };
  const [isPending, setIsPending] = useState<
    'Reenviar email' | 'Email enviado' | 'Enviar novamente' | 'Pendente'
  >('Reenviar email');
  // const uuid = urlParams.get('uuid')?.replace(' ', '+');
  function setStrongOnFirstWord(description: string) {
    const firstWord = description.split(' ')[0];
    const formattedDescription = description.replace(firstWord, '');

    return (
      <>
        <strong>{firstWord}</strong>
        {formattedDescription}
      </>
    );
  }

  const handleOnClose = () => {
    setShowModal(false);
    onClose && onClose();
  };

  return (
    <S.Wrapper aria-label="wrapper" showModal={showModal}>
      <S.Container noIconContainer={noIconContainer} isShort={isShort}>
        <S.Header>
          <S.IconWrapper onClick={handleOnClose}>
            <Icon
              icon="IcClose"
              aria-label={buttonLabel}
              style={{ color: 'black' }}
            />
          </S.IconWrapper>
        </S.Header>

        <S.Content noIconContainer={noIconContainer}>
          {!noIconContainer && (
            <S.IconContainer noBackground={noBackground}>
              {icon}
            </S.IconContainer>
          )}
          <S.Title>{name ? `${title} ${name}!` : title}</S.Title>

          <S.Description>
            {description && isStrong
              ? setStrongOnFirstWord(description)
              : description}
          </S.Description>

          <S.Description>{confirmation ? confirmation : ''}</S.Description>

          {hasButton && (
            <S.ButtonContainer>
              {isConfirmation === true ? (
                <Button
                  isLoading={isPending === 'Pendente'}
                  disabled={isPending === 'Email enviado'}
                  onClick={() => ResendEmail(uuid, setIsPending)}
                  fullWidthMobile
                >
                  {isPending}
                </Button>
              ) : (
                <Button onClick={handleOnClose} fullWidthMobile>
                  {buttonLabel}
                </Button>
              )}
            </S.ButtonContainer>
          )}

          {showModal && (content ?? children)}
        </S.Content>
      </S.Container>
    </S.Wrapper>
  );
};
